import { useEffect } from 'react';
import { useWatch } from 'react-hook-form';

import { useJobPostingContext } from '@/contexts/job-posting-context';

import { AudienceMessageSection } from './audience-message-section';
import { CampaignSettingsCard } from './campaign-settings-card';

export function PoolSetup() {
  const { hookForm, setCurrentStep } = useJobPostingContext();

  const pool = useWatch({ control: hookForm.control, name: 'channels.pool' });

  useEffect(() => {
    if (!pool) {
      setCurrentStep('select-channels');
    }
  }, [pool, setCurrentStep]);

  if (!pool) return null;

  return (
    <>
      <CampaignSettingsCard />
      <AudienceMessageSection />
    </>
  );
}
